import Vue from "vue";
import Vuex from "vuex";

import getters from './getters';
import mutations from './mutations';
import actions from './actions';

import cache from './plugins/cache';
import sync from './plugins/sync.js';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        //flag to see if store allready was loaded from cache initially, if not load data from cache
        initialized: false,
        isLoggedIn:false,
        keepData:false,
        tokens:{
            accessToken:'',
            refreshToken:''
        },
        features:{
            //featureArray:['time',"timeCountry","timeMileage"],
            featureArray:['time',"timeCountry","toDo"],
        },
        status:{
            value:'',
            footerMsg:{
            text:'',
            //error, warning, success, neutral: 
            type:'neutral',
            active:false,
            },
            optionsPopup:{
            active:false,
            field:{},
            option:-1,
            },
            lockPopup:{
            active:false,
            field:{},
            type:"",
            },
            refreshCount:0,
        },
        isNavOpen:false,
        user:{
            firstName:'',
            lastName: '', 
            street: '/',
            nr: '/',
            plz: '/',
            city: '/',
            email: '/',
            count: 0,
            licenseDate: 324,
            preDriveChecks: 0,
            posDriveChecks: 0,
            neutralDriveChecks: 0,
            negDriveChecks: 0,
            languageCode:0,
        },
        vehiclesAPI:{
            vehicles:{},
            trailers:{},
        },
        local:{
            sentDefects:[],
            nachtragTimer:{
                currentlyTracked:'none',
                trackedTimesEntries:[],
                timerId:0,
                startTimeActualTimer: -1,
                country:undefined,
            },
            curCheck:{
                lkwDataId:'lkw',
                timeId:'time',
                checkListId:[{
                    baseId:-1,
                    formId:-1
                }],
                defectsId:{
                    baseId:-1,
                    formId:-1
                },
                endId:{
                    baseId:-1,
                    formId:-1
                },
                toDoId:{
                    baseId:-1,
                    formId:-1
                },
                lkwFormId:{
                    baseId:-1,
                    formId:-1
                },
                startTime:undefined,
                chosenTruck: -1,
                chosenTrailer: -1,
                curTourId: -1,
                vehicleType:1,
                checklistStatus:{
                    lkw:{fieldStatus:'open', sendStatus:'open'},
                    time:{fieldStatus:'open', sendStatus:'open'}
                },
            },
            checkLists:{},
            checkResultsNew:{},
            formResults:{},
            documentation:{
                activePage:1,
                finishedChecks:{},
                tourDetails:{
                    submissions:[],
                    vehicle:{},
                    secondaryVehicles:[],
                    timers:[]
                }
            }
        },
    },
    getters,
    mutations,
    actions,
    plugins: [cache, sync],
    modules: {},
});
